import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { getTicketListOfCustomerUser, archiveTicketList } from '@/service/ticketService';
import { handleRestoreUser, updateUserResource } from '@/service/userService';
import { prepareTicketListWithoutNoticeGroup } from './CustomerListInProjectHandler';
import { getProjectListUserIsB2C, updateProjectDetail } from '@/service/projectService';

export const addNewRowProjectCustomer = (args) => {
    let newUserData = {
        id: Date.now().toString(),
        usage: Constant.SYSTEM_USAGE_TYPE.USER,
        affiliationOrganization: args.corporationId,
        mailAddress: '',
        status: Constant.STATUS_OF_USER.WAITING,
        firstName: '',
        lastName: '',
        isAddNew: true
    }

    let currentUserAddList = cloneDeep(args.userAddList);
    args.setUserAddList([newUserData, ...currentUserAddList]);
}   

export const isEmptyUserAddList = argsAll => {
    let count = 0;
    let userAddLists = cloneDeep(argsAll.userAddList);
    for (let i = 0; i < userAddLists.length; i++) {
        let user = userAddLists[i];
        if (
            Utils.isEmptyString(user.mailAddress) &&
            Utils.isEmptyString(user.firstName) &&
            Utils.isEmptyString(user.lastName)
        ) {
            count += 1;
        }
    }
    return count === userAddLists.length;
};

export const isChangeDataEdited = argsAll => { 
    let statusFlag = false;
    for(let i=0; i<argsAll.customerList.length; i++){
        if (
            !Utils.isNotChangedName(
                Constant.LANGUAGE_TYPE.JP,
                argsAll.customerList[i].firstName,
                argsAll.customerList[i].originFirstName
            ) ||
            !Utils.isNotChangedName(
                Constant.LANGUAGE_TYPE.JP,
                argsAll.customerList[i].lastName,
                argsAll.customerList[i].originLastName
            )
        ) {
            statusFlag = true;
            break;
        }
    }
    return statusFlag;
};

export const isDisplayPopupCancelAddOrEditChecker = argsAll => {
    if (!isEmptyUserAddList(argsAll) || isChangeDataEdited(argsAll)) {
        return true;
    }
    return false;
};

export const onClickCancelEdit = argsAll => {
    if (isDisplayPopupCancelAddOrEditChecker(argsAll)) {
        return argsAll.setIsOpenModalConfirmCancel(true);
    }
    argsAll.setUserAddList([]);
    argsAll.setIsEditMode(false);
    let newCustomerList = argsAll.customerList.map(customer => {
        if (customer.isEditMode) {
            delete customer.isEditMode;
            customer.firstName = customer.originFirstName;
            customer.lastName = customer.originLastName;
        }
        return customer;
    });
    argsAll.setCustomerList(newCustomerList);
    return;
};

export const clearDataAddUser = (args) => {
    let defaultData = {
        usage: Constant.SYSTEM_USAGE_TYPE.USER,
        affiliationOrganization: args.corporationId,
        mailAddress: '',
        status: Constant.STATUS_OF_USER.WAITING,
        firstName: '',
        lastName: ''
    }
    return defaultData;
}

export const isEmptyErrorEditUsers = argsAll => {
    let statusFlag = true;
    if (Utils.isEmptyObject(argsAll.errorEditUser)) {
        return statusFlag;
    }
    for (let user in argsAll.errorEditUser) {
        if (!Utils.isEmptyObject(argsAll.errorEditUser[user])) {
            statusFlag = false;
        }
    }
    return statusFlag;
};

export const isAddNewB2C = argAll => {
    return Utils.isEmptyArray(argAll.userAddList) ? false : true;
};

export const checkDisableBtnSubmit = argAll => {
    if (!isAddNewB2C(argAll) && !argAll.isEditMode) {
        argAll.setIsDisableBtnSubmit(true);
        return;
    } else if (isAddNewB2C(argAll) && !argAll.isEditMode) {
        argAll.setIsDisableBtnSubmit(!Utils.isEmptyObject(validateUserAddList(argAll.userAddList)));
        return;
    } else if (argAll.isEditMode && !isAddNewB2C(argAll)) {
        argAll.setIsDisableBtnSubmit(
            !(isChangeDataEdited(argAll) && isEmptyErrorEditUsers(argAll))
        );
        return;
    } else {
        argAll.setIsDisableBtnSubmit(
            !(
                isChangeDataEdited(argAll) &&
                isEmptyErrorEditUsers(argAll) &&
                Utils.isEmptyObject(validateUserAddList(argAll.userAddList))
            )
        );
        return;
    }
};

export const validatedEmail = (email, userAddList, userId) => {
    let errors;
    // validate email
    if (Utils.isEmptyString(email.trim())) {
        errors = I18n.get('COMMSG014');
    } else if (!Utils.validateEmail(email.trim())) {
        errors = I18n.get('COMM01MSG07');
    } else if (email.trim().length > Constant.EMAIL_MAX_LENGTH) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', Constant.EMAIL_MAX_LENGTH);
    } else if(email.trim().length < 4) {
        errors = I18n.get('COMMSG026').replace('{{minLength}}', 4);
    } 
    else {
        let emails = userAddList.filter(x => x.mailAddress.trim().toLowerCase() === email.trim().toLowerCase() && x.id !== userId);
        let isExistEmail = emails && emails.length > 0 ? true : false;
        if (isExistEmail) {
            errors = I18n.get('USER09MSG007');
        } else {
            errors = '';
        }
    }

    return errors;
};

export const validatedNameUser = name => {
    let errors;
    if (Utils.isEmptyString(name.trim())) {
        errors = I18n.get('COMMSG014');
    } else if (name.trim().length > 200) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', '200');
    } else {
        errors = '';
    }

    return errors;
};

export const findMailDuplicate = (userAddList) => {
    let valueArr = userAddList.map(item => item.mailAddress.trim().toLowerCase()).filter(item => !!item);
    const mailDuplicate = valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx);
    return mailDuplicate;
}

export const handleTextFieldAddChange = (event, userId, args) => {
    let currentAddList = cloneDeep(args.userAddList);
    let errorAddList = args.errorAddList;
    let inputValue = event.target.value;
    let errorsRow = errorAddList[`${userId}`] ? errorAddList[`${userId}`] : {};
    const index = Utils.findIndexInArrayById(userId, currentAddList);
    let errors = '';
    switch (event.target.id) {
        case `mailAddress-${userId}`:
            errors = validatedEmail(inputValue, currentAddList, userId)
            if(!Utils.isEmptyString(errors)) {
                errorsRow.email = errors;
                errorAddList[`${userId}`] = errorsRow;
                args.setErrorAddList(errorAddList);

                currentAddList[index].mailAddress = inputValue;
            }
            else {
                delete errorsRow.email ;
                errorAddList[`${userId}`] = errorsRow;
                args.setErrorAddList(errorAddList);
                
                currentAddList[index].mailAddress = inputValue;
            }
            break;
        case `firstName-${userId}`:
            errors = validatedNameUser(inputValue);

            if (!Utils.isEmptyString(errors)) {
                errorsRow.firstName = errors;
                errorAddList[`${userId}`] = errorsRow;
                args.setErrorAddList(errorAddList);
        
            } else {
                delete errorsRow.firstName;
                errorAddList[`${userId}`] = errorsRow;
                args.setErrorAddList(errorAddList);
        
            }
            currentAddList[index].firstName = inputValue;
            break;
        case `lastName-${userId}`:
            errors = validatedNameUser(inputValue);

            if (!Utils.isEmptyString(errors)) {
                errorsRow.lastName = errors;
                errorAddList[`${userId}`] = errorsRow;
                args.setErrorAddList(errorAddList);
        
            } else {
                delete errorsRow.lastName;
                errorAddList[`${userId}`] = errorsRow;
                args.setErrorAddList(errorAddList);
        
            }
            currentAddList[index].lastName = inputValue;
            break;
        default:
            return;
    }
    args.setUserAddList(currentAddList);

    let mailDuplicate = findMailDuplicate(currentAddList);
    currentAddList.forEach(item => {
        if (!mailDuplicate.includes(item.mailAddress.trim().toLowerCase()) && errorAddList[`${item.id}`]?.email === I18n.get('USER09MSG007')) {
            delete errorAddList[`${item.id}`]?.email;
            args.setErrorAddList(errorAddList);
        }
    });
    
}

export const onDeleteAddUser = (userId, args) => {
    let currentAddList = cloneDeep(args.userAddList);
    currentAddList = currentAddList.filter((e, i) => e.id !== userId);
    args.setUserAddList(currentAddList);
}

export const validateUserAddList = (userAddList) => {
    if (Utils.isEmptyArray(userAddList)) return;

    let errors = {};
    userAddList.forEach(user => {
        errors[`${user.id}`] = {};

        let errorLastName = validatedNameUser(user.lastName);
        if (!Utils.isEmptyString(errorLastName)) {
            errors[`${user.id}`].lastName = errorLastName;
        } else {
            delete errors[`${user.id}`].lastName;
        }

        let errorFirstName = validatedNameUser(user.firstName);
        if (!Utils.isEmptyString(errorFirstName)) {
            errors[`${user.id}`].firstName = errorFirstName;
        } else {
            delete errors[`${user.id}`].firstName;
        }

        let errorEmail = validatedEmail(user.mailAddress, userAddList, user.id);
        if (!Utils.isEmptyString(errorEmail)) {
            errors[`${user.id}`].email = errorEmail;
        } else {
            delete errors[`${user.id}`].email;
        }
    });

    let errorList = {};
    for(let key in errors) {
        if(!Utils.isEmptyObject(errors[key])) {
            errorList[key] = errors[key];
        }
    }
    
    return errorList;
}

export const reMoveRowProjectUser = (argsAll, id, userAddList, setUserAddList) => {
    let errorsList = argsAll.errorAddList;
    let currentAddList = cloneDeep(userAddList);

    currentAddList = currentAddList.filter((e, i) => e.id !== id);
    let mailDuplicate = findMailDuplicate(currentAddList);
    currentAddList.forEach(item => {
        if (!mailDuplicate.includes(item.mailAddress.trim().toLowerCase()) && errorsList[`${item.id}`]?.email === I18n.get('USER09MSG007')) {
            delete errorsList[`${item.id}`]?.email;
            argsAll.setErrorAddList(errorsList);
        }
    });
    setUserAddList(currentAddList);
};


export const onSubmitCancelEdit = (args) => {
    let userAddList = cloneDeep(args.userAddList);
    let newCustomerList = cloneDeep(args.customerList);
    userAddList = userAddList.map((item, index) => {
        return {
            ...item,
            usage: Constant.SYSTEM_USAGE_TYPE.USER,
            affiliationOrganization: args.corporationId,
            mailAddress: '',
            status: Constant.STATUS_OF_USER.WAITING,
            firstName: '',
            lastName: '',
            isAutocomplete: false
        }
    })
    
    newCustomerList = newCustomerList.map(customer => {
        if (customer.isEditMode) {
            delete customer.isEditMode;
            customer.firstName = customer.originFirstName;
            customer.lastName = customer.originLastName;
        }
        return customer;
    });
    args.setIsEditMode(false);
    args.setCustomerList(newCustomerList);
    args.setErrorAddList([]);
    args.setUserAddList(userAddList);
    args.setErrorEditUser([]);
}

export const isFillUserData = (list, id) => {
    try {
        let listClone = cloneDeep(list);
        const indexOfItem = Utils.findIndexInArrayById(id, list);

        let status = false;

        for (let key in listClone[indexOfItem]) {
            if (['mailAddress', 'firstName', 'lastName'].includes(key)) {
                if (typeof listClone[indexOfItem][key] !== 'string') {
                    throw new Error('List fields contain some elements which are not string type');
                }
                status = status | !Utils.isEmptyString(listClone[indexOfItem][key]);
            }
        }
        return status;
    } catch (err) {
        console.error({ PopupDeleteItem: err });
        return true;
    }
};

export const getNewUserEdited = (user) => {
    let newUserEdited = {
        id: user.id,
        firstName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, user.firstName),
        lastName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, user.lastName)
    }
    return newUserEdited;
}

export const handleSubmit = async args => {
    // arr user add list 
    let userAddList = cloneDeep(args.userAddList);
    let errors = validateUserAddList(userAddList);
    args.setErrorAddList(errors);

    if(!Utils.isEmptyArray(userAddList)){
        userAddList = userAddList?.map(addUserInfo => {
            return {
                ...addUserInfo,
                mailAddress: addUserInfo.mailAddress?.trim().toLowerCase(),
                privilege: '',
                userType: Constant.USER_TYPE.CUSTOMER,
                firstName: addUserInfo.firstName?.trim(),
                lastName: addUserInfo.lastName?.trim(),
                affiliationOrganization: args.corporationId
            }
        })
    };

    // arr edit user list 
    let usersEditSubmit = args.customerList.filter(
        user =>
            user.isEditMode &&
            (!Utils.isNotChangedName(
                Constant.LANGUAGE_TYPE.JP,
                user.firstName,
                user.originFirstName
            ) ||
                !Utils.isNotChangedName(
                    Constant.LANGUAGE_TYPE.JP,
                    user.lastName,
                    user.originLastName
                ))
    );

    let uniqueUserArray = [...userAddList, ...usersEditSubmit];

    let paramsUpdateUserList = {
        userList: JSON.stringify(uniqueUserArray),
        corporationId: args.corporationDetail.id,
        actionFlag: Constant.CUSTOMERMANAGEMENT_ACTION_FLAG.CREATE_AND_UPDATE_CUTOMER_IN_CORP,
        idOfCurrentUser: args.userDetail.id
    }

    args.setIsLoading(true);
    let result = await updateUserResource(args.API, paramsUpdateUserList);
    if (!result.status) {
        if (result?.error) {
            args.enqueueSnackbar(I18n.get(result?.error), {
                variant: 'error',
                autoHideDuration: 3000
            });
        }
        args.setIsLoading(false);
        return;
    }

    let msgNoticeSuccess = I18n.get('MSG-CM-UPDATE-DATA-SUCCESS');
    const userSuccessList = Utils.convertJSONDataToObject(result.userSuccessList);
    if(!Utils.isEmptyArray(userAddList) && result.status) {
        let addUserError = {};
        let listAddUserFail = [];

        const listUserAddFail = Utils.convertJSONDataToObject(result.userFailList);
        if (!Utils.isEmptyArray(userSuccessList) && userAddList.length === uniqueUserArray.length) {
            msgNoticeSuccess = I18n.get('USER09MSG003');
        }
        if (!Utils.isEmptyArray(listUserAddFail)) {
            listUserAddFail?.forEach(userFailInfo => {
                const addUserInfo = userAddList.find(addUserInfoItem => {
                    return addUserInfoItem?.mailAddress?.trim()?.toLowerCase() === userFailInfo?.email?.trim()?.toLowerCase();
                });
                listAddUserFail.push(addUserInfo);
                if (!Utils.isEmptyObject(addUserInfo)) {
                    addUserError[addUserInfo.id] = {
                        email: I18n.get(userFailInfo.errorCode)
                    };
                }
            });
        }

        args.setUserAddList([...listAddUserFail]);
        args.setErrorAddList({ ...addUserError });
        args.setReloadCustomer(!args.reloadListCustomer)
    }

    if (
        !(
            Utils.isEmptyArray(usersEditSubmit) &&
            Utils.isEmptyArray(userSuccessList) &&
            !Utils.isEmptyArray(userAddList)
        )
    ) {
        args.setReloadCustomer(true);
        args.enqueueSnackbar(msgNoticeSuccess, {
            variant: 'success',
            autoHideDuration: 3000
        });
    }
};


/**
 * isDisableBtnDeleteB2C
 * is disable btn delete b2c user
 * @param {*} argsAll 
 * @returns 
 */
export const isDisableBtnDeleteB2C = (argsAll, user) => {
    if (!argsAll.userDetail || Utils.isEmptyObject(argsAll.userDetail) || !Utils.isAdminUser(argsAll.userDetail)) {
        return true;
    }

    if (!user || Utils.isEmptyObject(user) || user.active === Constant.ACTIVE_FLAG.DELETED) {
        return true;
    }

    return false;
}

/**
 * 
 * @param {*} isAdmin 
 * @param {*} user 
 */
export const isDisableBtnEditB2C = (isAdmin, user) => {
    return !isAdmin || user.active === Constant.ACTIVE_FLAG.DELETED
}


/**
 * onClickDeleteB2C
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const onClickDeleteB2C = async (argsAll, user) => {
    if (!user || Utils.isEmptyObject(user)) {
        return;
    }

    argsAll.setIsOpenDialogConfirmDelete({
        isEnable: true,
        userId: user.id
    });
}


/**
 * handleDeleteB2CUser
 * @param {*} argsAll 
 * @param {*} userId 
 * @returns 
 */
export const handleDeleteB2CUser = async (argsAll, userId) => {
    if (!userId) return;
    argsAll.setIsLoading(true);

    // update users amount of corporation
    let userUpdated = {
        id: userId,
        corporationId: argsAll.corporationId,
    };

    let userListUpdate = {
        deletedUserId: userId,
        corporationId:  argsAll.corporationDetail.id,
        userList: JSON.stringify(userUpdated),
        actionFlag: Constant.USERMANAGEMENT_ACTION_FLAG.DELETE_B2C_CUSTOMER_IN_CORPORATION,
        idOfCurrentUser: argsAll.userDetail.id
    }
    
    let deleteB2CResult =  await updateUserResource(argsAll.API, userListUpdate);

    if (!deleteB2CResult) {
        argsAll.setIsLoading(false);
        return;
    }

    let getTicketListOfB2C = await getTicketListOfCustomerUser(
        argsAll.API,
        argsAll.corporationId,
        userId
    );

    // Archive ticket
    if (!Utils.isEmptyArray(getTicketListOfB2C)) {
        let allTicketOfUser = getTicketListOfB2C.filter(
            ticket =>
                ticket.public === Constant.TICKET_PUBLIC.PUBLIC &&
                ticket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.LIVE &&
                [
                    Constant.TICKET_TYPE.QA,
                    Constant.TICKET_TYPE.INTERNAL_QA,
                    Constant.TICKET_TYPE.EXTERNAL_QA,
                    Constant.TICKET_TYPE.DELEGATE,
                    Constant.TICKET_TYPE.BROADCAST_PARENT,
                    Constant.TICKET_TYPE.BROADCAST_CHILD
                ].includes(ticket.ticketType)
        );
        let ticketListToArchive = await prepareTicketListWithoutNoticeGroup(argsAll.API, allTicketOfUser);
        if (!Utils.isEmptyArray(ticketListToArchive)) {
            await archiveTicketList(argsAll.API, ticketListToArchive, argsAll.userDetail.id);
        }
    }

    // Delete B2C from all project
    let projectListUserIsCustomer = await getProjectListUserIsB2C(argsAll.API, userId);

    if (projectListUserIsCustomer && projectListUserIsCustomer.relationRecord && !Utils.isEmptyArray(projectListUserIsCustomer.relationRecord)) {
        let arrayPromiseDeleteB2CFromProject = [];
        projectListUserIsCustomer.relationRecord.forEach(project => {
            let objDeleteProjectB2C = {
                id: project.id,
                active: Constant.ACTIVE_FLAG.DELETED,
                type: project.type
            }
            arrayPromiseDeleteB2CFromProject.push(updateProjectDetail(argsAll.API, project.id, objDeleteProjectB2C));
        });
        await Promise.all(arrayPromiseDeleteB2CFromProject);
    }
    
    let currentUserIndexInCustomerList = Utils.findIndexInArrayById(userId, argsAll.customerList);
    let currentCustomerList = cloneDeep(argsAll.customerList);
    currentCustomerList[currentUserIndexInCustomerList].active = Constant.ACTIVE_FLAG.DELETED;
    argsAll.setCustomerList(currentCustomerList);
    argsAll.setIsLoading(false);
}

export const handleEdit = (user, args) => {
    let customerList = cloneDeep(args.customerList);
    customerList = customerList.map(customer => {
        return customer.id === user.id
            ? Object.assign(customer, {
                  isEditMode: true,
                  originFirstName: customer.firstName,
                  originLastName: customer.lastName
              })
            : customer;
    });
    args.setIsEditMode(true);
    args.setCustomerList(customerList);
};

export const validatedNameUserEditing = (event, name) => {
    let errors;
    if (Utils.isEmptyString(name.trim())) {
        errors = I18n.get('COMMSG014'); 
    } else if (name.trim().length > 200) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', '200'); 
    } else {
        errors = '';
    }

    return errors;
};

export const validateEditUser = (event, userId, args) => {
    let customerList = cloneDeep(args.customerList);
    let errorEditUser = args.errorEditUser;
    let inputValue = event.target.value;
    let errorsRow = errorEditUser[`${userId}`] ? errorEditUser[`${userId}`] : {};
    const index = Utils.findIndexInArrayById(userId, customerList);
    let errors = '';
    switch (event.target.id) {
        case `firstName-${userId}`:
            errors = validatedNameUserEditing(event, inputValue);

            if (!Utils.isEmptyString(errors)) {
                errorsRow.firstName = errors;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            } else {
                delete errorsRow.firstName;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            }

            customerList[index].firstName = JSON.stringify({
                jp: {
                    A: 'F',
                    text: inputValue
                }
            });
            break;
        case `lastName-${userId}`:
            errors = validatedNameUserEditing(event, inputValue);

            if (!Utils.isEmptyString(errors)) {
                errorsRow.lastName = errors;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            } else {
                delete errorsRow.lastName;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            }
            customerList[index].lastName = JSON.stringify({
                jp: {
                    A: 'F',
                    text: inputValue
                }
            });
            break;
        default:
            return;
    }
    args.setCustomerList(customerList);
};


/**
 * isDisableBtnRestoreB2C
 * @param {*} isAdmin 
 * @param {*} user 
 * @returns 
 */
export const isDisableBtnRestoreB2C = (isAdmin, user) => {
    if (!isAdmin || !user || Utils.isEmptyObject(user)) {
        return true;
    }

    if (![Constant.STATUS_OF_USER.DELETED, Constant.STATUS_OF_USER.REJECT].includes(Utils.getUserStatus(user))) {
        return true;
    }
    
    return false;
}


/**
 * handleClickRestoreB2C
 * @param {*} argsAll 
 * @param {*} user 
 */
export const handleClickRestoreB2C = (argsAll, user) => {
    if (!user || Utils.isEmptyObject(user)) {
        return;
    }

    argsAll.setSelectedUser(user);
    argsAll.setIsOpenDialogConfirmRestoreUser(true);
}


/**
 * onSubmitRestoreB2C
 * @param {*} argsAll 
 */
export const onSubmitRestoreB2C = async (argsAll) => {
    if (!argsAll || !argsAll.selectedUser || Utils.isEmptyObject(argsAll.selectedUser)) return;

    let restoreUserId = argsAll.selectedUser.id;
    let restoreB2CRequestDto = {
        userId: restoreUserId,
        type: Constant.RESTORE_USER_TYPE.B2C_IN_ORG,
        currentUserId: argsAll.userDetail.id,
        corporationId: argsAll.corporationId
    }

    argsAll.setIsLoading(true);
    let restoreResult = await handleRestoreUser(argsAll.API, restoreB2CRequestDto);
    if (!restoreResult) {
        argsAll.setIsLoading(false);
        return;
    }

    // console.log('restoreResult', restoreResult)

    if (!restoreResult.status) {
        argsAll.setIsLoading(false);
        if (!restoreResult?.errorMessage) {
            return;
        }

        if (restoreResult?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            argsAll.setIsOpenModalReloadPage(true);
        } else if (argsAll.setEditUserError){
            argsAll.setEditUserError(I18n.get(restoreResult?.errorMessage));
        }
        return;
    }

    // Reload
    argsAll.setReloadCustomer(!argsAll.reloadListCustomer);
    argsAll.setIsLoading(false);
    argsAll.enqueueSnackbar(I18n.get('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
}